export default {
      id: "rub-usage",
      viewBox: "0 0 20 25",
      url: __webpack_public_path__ + "img/icons.svg#rub",
      toString: function () {
        return this.url;
      }
    }